import { useCallback, useEffect, useState } from 'react';

import type { Tab } from './types';

const useTabs = (
  tabs: Tab[],
  key?: string,
): [StringNumberValue | null, (id: StringNumberValue | null) => void] => {
  const [selectedTabId, setSelectedTabId] = useState<StringNumberValue | null>(
    tabs[0]?.id,
  );

  useEffect(() => {
    setSelectedTabId(tabs[0]?.id);
  }, [key]);

  const selectTab = useCallback(
    (id: StringNumberValue | null) => setSelectedTabId(id),
    [],
  );

  return [selectedTabId, selectTab];
};

export default useTabs;
